// src/components/common/AcademicYearSelector.js
import React, { useMemo } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
	buildYearOptions,
	useAcademicYear,
} from "../../contexts/AcademicYearContext";

/**
 * Reusable academic-year dropdown for admin / report screens.
 *
 * Props:
 *   value     - currently selected year string (e.g. "2025-2026")
 *   onChange  - called with the new value
 *   size      - MUI size ("small" by default)
 *   label     - label text (defaults to "Academic Year")
 *   sx        - extra MUI sx overrides
 *   minWidth  - convenience knob for the FormControl width
 */
const AcademicYearSelector = ({
	value,
	onChange,
	size = "small",
	label = "Academic Year",
	sx,
	minWidth = 160,
}) => {
	const { currentAcademicYear } = useAcademicYear();

	const options = useMemo(
		() => buildYearOptions(currentAcademicYear),
		[currentAcademicYear]
	);

	const effectiveValue = value || currentAcademicYear;

	return (
		<FormControl size={size} sx={{ minWidth, ...sx }}>
			<InputLabel id="academic-year-selector-label">{label}</InputLabel>
			<Select
				labelId="academic-year-selector-label"
				label={label}
				value={effectiveValue}
				onChange={(e) => onChange?.(e.target.value)}>
				{options.map((year) => (
					<MenuItem key={year} value={year}>
						{year}
						{year === currentAcademicYear ? "  (current)" : ""}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default AcademicYearSelector;
